import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { SidebarService } from "../sidebar/sidebar.service";
import { VariablesEnum } from "src/app/auth/enum/variables.enum";
import { LocalStorageService } from "src/app/services/localstorage.service";
import { VariablesService } from "../../services/variableGL.service";
import { UsuarioCultura } from "src/app/models/cultura/usuario-cultura-model";
import { UsuarioCulturaService } from "src/app/services/cultura/usuario-cultura.service";

declare var $: any;

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  @ViewChild("modalChangePass", { static: false })
  modalChangePass: TemplateRef<any>;
  modalRefPass: any;

  authUs: UsuarioCultura = new UsuarioCultura();
  nombreCompleto: string = "";

  constructor(
    public sidebarservice: SidebarService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private variablesService: VariablesService,
    private serviceUser: UsuarioCulturaService,
  ) {
    const jsonValue = this.localStorageService.getJsonValue(
      VariablesEnum.usuario_conade,
    );

    if (jsonValue) {
      this.authUs = JSON.parse(jsonValue) || new UsuarioCultura();
      this.nombreCompleto =
        `${this.authUs?.nombre || ""} ${this.authUs?.aPaterno || ""} ${this.authUs?.aMaterno || ""}`.trim();

      if (this.authUs?.tipoUsuario === "Promotor") {
        this.authUs.tipoUsuario = "Embajador";
      }
    }
  }

  toggleSidebar() {
    this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());

    if ($("#wrapper").hasClass("nav-collapsed")) {
      $("#wrapper").removeClass("nav-collapsed");
      $("#sidebar-wrapper").unbind("hover");
    } else {
      $("#wrapper").addClass("nav-collapsed");
      $("#sidebar-wrapper").hover(
        function () {
          $("#wrapper").addClass("sidebar-hovered");
        },
        function () {
          $("#wrapper").removeClass("sidebar-hovered");
        },
      );
    }
  }

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  hideSidebar() {
    this.sidebarservice.setSidebarState(true);
  }

  ngOnInit() {}

  async Logout() {
    const token = localStorage.getItem("accessToken_26_producción"); //[cite: 8]

    if (token) {
      try {
        await this.serviceUser.logout(token);
      } catch (error) {
        console.error("Error consumiendo endpoint de Logout:", error);
      }
    }

    localStorage.clear();
    sessionStorage.clear();
    this.localStorageService.clearToken();

    this.router.navigate(["auth/signin"]);
  }

  openModal() {
    this.variablesService.modalCambiaContrasena.next(true);
  }
}
